import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

import { BreadcrumbsDynamic } from 'stories/components';
import { PageHeader } from "components/Page";
import DiaryTransactions from "views/app/DiaryTransactions/DiaryTransactions"

import { Typography } from "stories/components";

const Diary = (props) => {
  const { t } = useTranslation();

    //Export button from diaryTransactions
    const [exportButton, setExportButton] = useState(null);

  const getCrumbLinks = () => {
    const tail = { name: t("routes_dashboard_diary", "Päiväkirja"), url: "/dashboard/diary" };
    if (props.location?.state?.crumbLinks?.length) {
      return [...props.location.state.crumbLinks, tail];
    }
    return [
      { name: t("web_options_frontpage", "Etusivu"), url: "/dashboard/" },
      tail,
    ];
  };

  
  return (
    <>
    <div className="row">
      <div className="col">
        <PageHeader title={t("routes_dashboard_diary", "Päiväkirja")} />
        <BreadcrumbsDynamic links={getCrumbLinks()} />
      </div>
    </div>

    
      <DiaryTransactions  setExportButton={setExportButton}/>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-4">
        <Typography variant="small" className="mb-0 text-gray">
          * {t("diary_batch_exchange_date","Erän vaihtopäivämäärä")}
        </Typography>
        {exportButton}
      </div>



  
{/*
    <Row>
        <Col className="mb-3">
          <img src={graph01} />
        </Col>
        <Col className="mb-3">
          <img src={graph02} />
        </Col>
  </Row>*/}
    </>
  );
}

export default Diary;